<template>
  <div class="customer-tab-wrap">
    <v-row>
      <v-col cols="12">
        <div class="customer-tab">
          <ul class="nav nav-pills" id="pills-tab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link card-heading border-end"
                :class="{ active: activeTab === 'Activity' }"
                 @click.prevent="openTab('Activity')"
                id="activity-tab"
                data-toggle="pill"
                href="#pills-activity"
                role="tab"
                aria-controls="pills-activity"
                aria-selected="true"
                >Activity</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link card-heading border-end"
                :class="{ active: !showNotesTab , active: activeTab === 'Notes'}"
                 @click.prevent="openTab('Notes')"
                id="notes-tab"
                data-toggle="pill"
                href="#pills-notes"
                role="tab"
                aria-controls="pills-notes"
                aria-selected="false"
                >Notes</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link card-heading border-end"
                :class="{ active: activeTab === 'Email' }"
                 @click.prevent="openTab('Email')"
                id="emails-tab"
                data-toggle="pill"
                href="#pills-emails"
                role="tab"
                aria-controls="pills-emails"
                aria-selected="false"
                >Emails</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link card-heading border-end"
                :class="{ active: activeTab === 'Meet' }"
                 @click.prevent="openTab('Meet')"
                id="mettings-tab"
                data-toggle="pill"
                href="#pills-mettings"
                role="tab"
                aria-controls="pills-mettings"
                aria-selected="true"
                >Meetings</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link card-heading border-end"
                :class="{ active: !showTaskTab , active: activeTab === 'Task'}"
                 @click.prevent="openTab('Task')"
                id="tasks-tab"
                data-toggle="pill"
                href="#pills-tasks"
                role="tab"
                aria-controls="pills-tasks"
                aria-selected="false"
                >Tasks</a
              >
            </li>
          </ul>
        </div>
        <!-- activity tabs -->
        <div
          class="accordionByDate fade"
          :class="{ show: activeTab === 'Activity', active: activeTab === 'Activity' }"
          id=""
          aria-labelledby="activity-tab"
        >
          <div class="tabWrapper" v-if="showNotesTab">
            <activity-tab   :showCreateNote="showCreateNote"  :leadNotes="Note"  :customerDetail="demo" />   
          </div>
        </div>

        <!-- notes -->
        <div
          class="accordionByDate notesTab fade"
          :class="{ show: activeTab === 'Notes', active: activeTab === 'Notes' }"
          id=""
          aria-labelledby="notes-tab"
        >
            <button class="backButton" :class="{ 'd-none': showNotesTab }" @click="toggleView('notes')">
            <img :src="arrowTurnIcon"/>
              Back
            </button>
          <div class="tabWrapper" v-if="showNotesTab">
            <notes-tab :showCreateNote="showCreateNote"  :leadNotes="Note"  :customerDetail="demo"   @showAddNoteComponent="createNote"/>
          </div>
          <support_comment v-else @close="toggleView('notes')" :form-data="formData"  @updateNoteTabValue="NoteTabActive" />
<!--          <create-notes v-else @close="toggleView('notes')" :leadNotes="Note"  :customerDetail="demo"  @updateNoteTabValue="NoteTabActive" />-->
        </div>
        <!-- emails -->
        <div
          class="accordionByDate fade"
          :class="{ show: activeTab === 'Email', active: activeTab === 'Email' }"
          id=""
          aria-labelledby="emails-tab"
        >
          <div class="tabWrapper">
            <email-tab  />
          </div>
        </div>

        <!-- meetings -->
        <div
          class="accordionByDate fade"
          :class="{ show: activeTab === 'Meet', active: activeTab === 'Meet' }"
          id=""
          aria-labelledby="mettings-tab"
        >
          <div class="tabWrapper">
            <meeting-tab  />
          </div>
        </div>

        <!-- tasks -->
        <div
          class="accordionByDate fade tasksTabWrapper"
          :class="{ show: activeTab === 'Task', active: activeTab === 'Task' }"
          id=""
          aria-labelledby="tasks-tab"
        >
            <button class="backButton" :class="{ 'd-none': showTaskTab }" @click="toggleView('tasks')" >
              <img :src="arrowTurnIcon"/>
              Back
            </button>
          <div class="taskTabWrapper" v-if="showTaskTab">
            <tasks-tab  :showCreateTask="showCreateTask" :tasksList="quickTasks"  @editable="editable"/>
          </div>

          <create-tasks v-else @close="toggleView('tasks')" :editMode="isEdit" :taskId="editTaskId"  @updateTaskTabValue="setTaskTabActive" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import pencilEdit from "../../assets/images/pencil-edit.svg";
import editIcon from "../../assets/images/edit2.svg";
import deleteIcon from "../../assets/images/delete.svg";
import arrowTurnIcon from "@/assets/images/arrow-turn.svg"
import CreateNotes from "./create-notes.vue";
import CreateTasks from "./create-task.vue";

import ActivityTab from "./allTabs/activity-tab.vue";
import NotesTab from "./allTabs/notes-tab.vue";
import EmailTab from "./allTabs/email-tabs.vue";
import MeetingTab from "./allTabs/meeting-tab.vue";
import TasksTab from "./allTabs/tasks-tab.vue";
import Support_comment from "@/components/support/support_comment.vue";

export default {
  name: "CustomerTabs",
  props: ['activeTab'],
  components: {
    Support_comment,
    CreateNotes,
    CreateTasks,
    ActivityTab,
    NotesTab,
    EmailTab,
    MeetingTab,
    TasksTab,

  },
  data() {
    return {
      deleteIcon: deleteIcon,
      editIcon: editIcon,
      pencilEdit: pencilEdit,
      arrowTurnIcon:arrowTurnIcon,
      showNotesTab: true,
      showTaskTab: true,
      isEdit: false,
      editTaskId: null,
      formData: {
        lead_id: this.$route.params.id,
      }
    };
  },

  mounted() {
    this.$store.dispatch('users/getLeadNotes', ["lead_id",this.$route.params.id]);
    this.handleCollapse();
    this.getRecords();
  },
  computed: {
    demo: function () {
      return this.$store.getters['users/demoRequest'];
    },
    demoNote: function () {
      return this.$store.getters['users/demoRequestNotes'];
    },
    Note: function () {
      return this.$store.getters['users/leadNotes'];
    },
    onBoarding: function () {
      return this.$store.getters['users/onBoarding'];
    },

    quickTasks: function () {
      return this.$store.getters["quick_task/tasks"];
    },
  },

  created: function () {
    this.$store.dispatch('users/getLeadNotes', ["lead_id",this.$route.params.id]);
  },
  methods: {
    handleCollapse() {
      this.$nextTick(() => {
        const collapseElement = document.getElementById("collapseOne");
        const accordionHeading = document.querySelector(".accordion-heading");
        const accordionHeading1 = document.querySelector(".accordion-heading1");
        const accordionPara = document.querySelector(".accordion-para");

        if (
          collapseElement &&
          accordionHeading &&
          accordionHeading1 &&
          accordionPara
        ) {
          $(collapseElement).on("show.bs.collapse", function () {
            accordionHeading.classList.add("accordion-heading-collapsed");
            accordionHeading1.classList.add("accordion-heading-hidden");
            accordionPara.classList.add("accordion-heading-hidden");
          });

          $(collapseElement).on("hide.bs.collapse", function () {
            accordionHeading.classList.remove("accordion-heading-collapsed");
            accordionHeading1.classList.remove("accordion-heading-hidden");
            accordionPara.classList.remove("accordion-heading-hidden");
          });
        }
      });
    },

    
    showCreateNote() {
      this.showNotesTab = false;
    },
    showCreateTask() {
      this.showTaskTab = false;
    },
    setTaskTabActive(value) {
      this.showTaskTab = value;
      this.isEdit = false;
      this.editTaskId = null;
    },


    NoteTabActive(value) {
      this.showNotesTab = value;
    },

    toggleView(view) {
      console.log(view);
      
    if (view === 'tasks') {
      this.showTaskTab = !this.showTaskTab;
      // this.showCreateTask = !this.showCreateTask; // Toggle the create task view
    } else if (view === 'notes') {
      this.showNotesTab = !this.showNotesTab;
      // this.showCreateNote = !this.showCreateNote; // Toggle the create note view
    }
  },
   openTab(tabName) {
      this.$emit('tab-selected', tabName);
    },

    getRecords() {
      this.$store.dispatch("quick_task/getAllTask", [1, 0, null, null, null, {'key':'lead_id','id':this.$route.params.id}])
          .then(() => {
            this.setskeletonLoader(false);
          }).catch(() => {
        this.setskeletonLoader(false);
      });
    },


    editable(id){
      this.isEdit = true;
      this.editTaskId = id;
      this.showTaskTab = false;

      },
    createNote(value){
        this.showNotesTab = value
    }
  },
};
</script>
